import { render, staticRenderFns } from "./setting-exchange.vue?vue&type=template&id=555c2972"
import script from "./setting-exchange.vue?vue&type=script&lang=js"
export * from "./setting-exchange.vue?vue&type=script&lang=js"
import style0 from "./setting-exchange.vue?vue&type=style&index=0&id=555c2972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports